// src/components/Header.tsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Menu, X, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";

// --- استایل‌های جدید برای تم روشن ---
const HeaderContainer = styled.header`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 1000;
  direction: rtl;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 76px;
  max-width: 1280px;
  margin: 0 auto;
`;

const Logo = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  background: linear-gradient(90deg, #4a90e2, #9010d8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
`;

const NavList = styled.ul<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 24px 20px;
  gap: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    position: static;
    background: transparent;
    border: none;
    padding: 0;
    gap: 40px;
    box-shadow: none;
  }
`;

const NavItem = styled.li`
  list-style: none;
`;

const NavLink = styled.a`
  color: #4a5568;
  text-decoration: none;
  font-size: 1.05rem;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;

  &:hover {
    color: #4a90e2;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const LogoutButton = styled.button`
  background: linear-gradient(135deg, #ff4d4f, #ff7878);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 77, 79, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 77, 79, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const HamburgerButton = styled.button`
  background: none;
  border: none;
  color: #2d3748;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(74, 144, 226, 0.1);
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

// --- کامپوننت اصلی ---
const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <HeaderContainer>
      <Nav>
        <Logo>سامانه سمنتا</Logo>

        <NavList isOpen={isMobileMenuOpen}>
          <NavItem>
            <NavLink
              href="https://contagion.100gan.ir/dashboard-page"
              target="_blank"
              rel="noopener noreferrer"
            >
              صفحه نخست
              <ExternalLink size={16} />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink onClick={() => navigate("/dashboard-page")}>
              داشبورد سامانه
            </NavLink>
          </NavItem>
          <NavItem>
            <LogoutButton onClick={handleLogout}>
              <LogOut size={18} />
              خروج از حساب
            </LogoutButton>
          </NavItem>
        </NavList>

        <HamburgerButton onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </HamburgerButton>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
